"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoPushpinChartDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableGeoPushpinChart_1 = require("./PluggableGeoPushpinChart");
var constants_1 = require("../constants");
var BaseChartDescriptor_1 = require("../baseChart/BaseChartDescriptor");
var GeoPushpinChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(GeoPushpinChartDescriptor, _super);
    function GeoPushpinChartDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GeoPushpinChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableGeoPushpinChart_1.PluggableGeoPushpinChart(params); };
    };
    GeoPushpinChartDescriptor.prototype.getSizeInfo = function (_insight, layoutDescriptor, settings) {
        return {
            width: {
                default: 6,
                min: 6,
                max: layoutDescriptor.gridColumnsCount,
            },
            height: {
                default: this.getDefaultHeight(settings.enableKDWidgetCustomHeight),
                min: this.getDefaultHeight(settings.enableKDWidgetCustomHeight),
                max: this.getMaxHeight(settings.enableKDWidgetCustomHeight),
            },
        };
    };
    GeoPushpinChartDescriptor.prototype.getMinHeight = function (enableCustomHeight) {
        if (!enableCustomHeight) {
            return constants_1.DASHBOARD_LAYOUT_DEFAULT_VIS_HEIGHT;
        }
        return constants_1.MIDDLE_VISUALIZATION_HEIGHT;
    };
    return GeoPushpinChartDescriptor;
}(BaseChartDescriptor_1.BaseChartDescriptor));
exports.GeoPushpinChartDescriptor = GeoPushpinChartDescriptor;
//# sourceMappingURL=GeoPushpinChartDescriptor.js.map